module.exports = __webpack_public_path__ + "static/media/embeds.21ddf27f.webp";